import type { SkillListFilter } from "@models";
import { FilterList } from "@mui/icons-material";
import { Box, Chip, Typography } from "@mui/material";
import { GenericFilterMenu } from "src/components/ui/GenericFilterMenu";
import type { SkillsFilterMenuProps } from "../types";

export const SkillsFilterMenu = ({
  filter,
  onFilterChange,
}: SkillsFilterMenuProps) => {
  const isFilterActive = filter !== "all";

  return (
    <GenericFilterMenu
      id="skills-filter-menu"
      triggerId="skills-filter-button"
      triggerAriaLabel="Filter skills"
      closeAriaLabel="Close skills filters"
      triggerTooltip="Filter skills"
      triggerIcon={<FilterList fontSize="small" />}
      hasActiveFilters={isFilterActive}
      triggerSx={{
        backgroundColor: isFilterActive
          ? "rgba(7, 78, 232, 0.08)"
          : "transparent",
        ...(isFilterActive ? { color: "primary.main" } : {}),
      }}
      contentTestId="skills-filter-content"
      headerTestId="skills-filter-header"
      bodyTestId="skills-filter-body"
      popperTestId="skills-filter-popper"
      onResetFilters={() => onFilterChange("all")}
      bodySx={{ padding: "12px 14px" }}
    >
      <Typography sx={{ mb: 1 }}>Visibility</Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "4px",
        }}
      >
        {(
          [
            { label: "All", value: "all" },
            { label: "Private", value: "private" },
            { label: "Org", value: "organization" },
            { label: "Global", value: "global" },
            { label: "Formly", value: "formly_internal" },
          ] satisfies Array<{ label: string; value: SkillListFilter }>
        ).map((item) => (
          <Chip
            key={item.value}
            label={item.label}
            size="small"
            color={filter === item.value ? "info" : "default"}
            sx={{
              width: "fit-content",
              ...(filter === item.value
                ? {
                    "&&": {
                      backgroundColor: "#5d85ff2b",
                      color: "inherit",
                    },
                    "&&:hover": {
                      backgroundColor: "#5d85ff2b",
                      color: "inherit",
                    },
                  }
                : {}),
            }}
            onClick={() => onFilterChange(item.value)}
            aria-pressed={filter === item.value}
          />
        ))}
      </Box>
    </GenericFilterMenu>
  );
};
